import {
  ResponsiveContainer,
  Cell,
  Pie,
  PieChart,
  Tooltip,
  Legend,
} from "recharts";

const shortenDepartmentName = (name) => {
  const mappings = {
    "Department of Arts and Language Education": "Arts & Language",
    "Department of Mathematics and Computer Science Education ":
      "Math & Computer",
    "Department of Science Education ": "Science",
  };
  return mappings[name] || name;
};

export default function ScholarshipRequestsDepartmentChart({ data }) {
  const processedData = data?.map((item) => ({
    ...item,
    shortName: shortenDepartmentName(item.department),
  }));

  return (
    <>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={processedData}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={110}
            fill="#8884d8"
            dataKey="total"
            nameKey="shortName"
            label={({ name, value, percent }) =>
              `${value?.toLocaleString()} (${(percent * 100).toFixed(0)}%)`
            }
          >
            {processedData?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={`hsl(var(--chart-${index + 1}))`}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, label, props) => [
              `${value?.toLocaleString()} ${
                value == 1 ? "Teacher" : "Teachers"
              }`,
              props.payload.department,
            ]}
          />
        </PieChart>
      </ResponsiveContainer>
      <table
        style={{ borderCollapse: "collapse", width: "100%", marginTop: "30px" }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f9f9f9" }}>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "10px 10px 10px 20px",
                textAlign: "left",
              }}
            >
              Department
            </th>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Male
            </th>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Female
            </th>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr
              key={index}
              style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}
            >
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px 10px 10px 20px",
                }}
              >
                {item.department}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {item.male?.toLocaleString()}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {item.female?.toLocaleString()}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {item.total?.toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
